import { useMemo } from 'react';
import { casinoRouteForLobby } from '../../data/casinoData';
import { useCasinoStats } from '../../hooks/useCasinoGameFeed';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useSiteContent } from '../../context/SiteContentContext';
import { useLocale } from '../../context';
import { withAssetCacheVersion } from '../../utils/assetCache';

const MOBILE_SHOWCASE_IDS = ['slots', 'live', 'tv', 'sport'];

function formatGameCount(count, locale, tr) {
  const n = Number(count) || 0;
  if (locale === 'tr') {
    return tr('home.showcase.gamesCount', { count: n.toLocaleString('tr-TR') });
  }
  return tr('home.showcase.gamesCount', { count: n.toLocaleString('en-US') });
}

export default function ShowcaseRow({ onNavigate, reveal = true }) {
  const _locale = useLocale();
  const tr = _locale.t;
  const locale = _locale.locale;
  const isMobile = useIsMobile();
  const { showcaseCards } = useSiteContent();
  const { stats } = useCasinoStats();

  const cards = showcaseCards.map((card) => {
    if (card.sport) {
      return {
        ...card,
        count: null,
      };
    }
    if (!card.lobbyKey || card.count) return card;
    const count = stats?.[card.lobbyKey];
    return {
      ...card,
      count: count != null ? formatGameCount(count, locale, tr) : '…',
    };
  });

  const visibleCards = isMobile
    ? cards.filter((card) => MOBILE_SHOWCASE_IDS.includes(card.id))
    : cards;

  if (!visibleCards.length) return null;

  return (
    <section
      className={`show-case-area${isMobile ? ' show-case-area--mobile-frame' : ''}`}
      {...(reveal ? { 'data-reveal': 'section' } : {})}
    >
      <div className="show-case-area__scroll">
        {visibleCards.map((c) => (
          <div
            key={c.id}
            className={`show-case-area__column show-case-area__column--${c.id}`}
            data-reveal-item
          >
            <a
              href="#"
              className="showcase-card"
              tabIndex={-1}
              onClick={(e) => {
                e.preventDefault();
                if (c.sport) {
                  onNavigate('sport');
                  return;
                }
                onNavigate('casino', casinoRouteForLobby(c.lobbyKey || 'slots'));
              }}
            >
              <div className="showcase-card__jump-wrapper">
                <div className="showcase-card__jump">
                  <div
                    className="showcase-card__panel"
                    style={{
                      backgroundImage: `linear-gradient(${c.gradientFrom || '#d4004b'} 0%, ${c.gradientTo || '#79002c'} 100%)`,
                    }}
                  >
                    <div
                      className="showcase-card__title"
                      style={{ width: c.titleWidth }}
                    >
                      {c.title}
                    </div>
                    {c.count != null && c.count !== '' && (
                      <div className="showcase-card__count">{c.count}</div>
                    )}
                    {!isMobile && (
                      <div className="showcase-card__link">
                        {c.link}
                      </div>
                    )}
                  </div>
                  {(isMobile ? (c.mobileImg || c.img) : c.img) && (
                    <img
                      className="showcase-card__img"
                      src={withAssetCacheVersion(isMobile ? (c.mobileImg || c.img) : c.img)}
                      alt=""
                      loading="lazy"
                    />
                  )}
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
